/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Body2Inputs */

const en_formatter_body2 = /** @type {(inputs: Formatter_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The practical benefit is that formatting doubles as validation. A trailing comma, an unquoted key, or an unbalanced bracket fails at the parse step and is reported instead of silently producing broken output. When an API response will not load in your code, running it through the formatter is the fastest way to find out whether the payload itself is malformed or your parsing code is at fault.`)
};

const ko_formatter_body2 = /** @type {(inputs: Formatter_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실용적인 이점은 포매팅이 곧 검증이라는 점입니다. 뒤에 남은 쉼표, 따옴표 없는 키, 짝이 맞지 않는 괄호는 파싱 단계에서 실패하고 오류로 보고됩니다. 깨진 출력을 조용히 만들어내지 않습니다. API 응답이 코드에서 로드되지 않을 때, 페이로드 자체가 잘못된 것인지 파싱 코드가 문제인지 가장 빠르게 가려내는 방법입니다.`)
};

const ja_formatter_body2 = /** @type {(inputs: Formatter_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実用的な利点は、整形がそのまま検証になることです。末尾のカンマ、引用符のないキー、対応しない括弧はパース段階で失敗し、エラーとして報告されます。壊れた出力を黙って作ることはありません。API レスポンスがコードで読み込めないとき、ペイロード自体が壊れているのか、パース側の問題なのかを最短で切り分けられます。`)
};

/**
* | output |
* | --- |
* | "The practical benefit is that formatting doubles as validation. A trailing comma, an unquoted key, or an unbalanced bracket fails at the parse step and is re..." |
*
* @param {Formatter_Body2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_body2 = /** @type {((inputs?: Formatter_Body2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Body2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_body2(inputs)
	if (locale === "ko") return ko_formatter_body2(inputs)
	return ja_formatter_body2(inputs)
});